import {formattingDate} from "../utils/common";
import {replaceMnemonicSymbols} from "./utils";

export const getNotificationCreateTemplate = ({
                                                id,
                                                name,
                                                projectName,
                                                user,
                                                date,
                                                taskId,
                                              }, isSubItem) => `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--new-task" href="/task/${taskId}">
    <p class="notifications__name">Новая задача</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19" alt="Аватар пользователя ${user.name}">
    <div class="notifications__content">
      <p class="notifications__text">${name}</p>
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;

export const getNotificationOpenTemplate = ({
                                              id,
                                              name,
                                              projectName,
                                              user,
                                              date,
                                              taskId,
                                            }, isSubItem) => `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--open" href="/task/${taskId}">
    <p class="notifications__name">Задача открыта</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19"
      alt="Аватар пользователя ${user.name}">
    <div class="notifications__content">
      <p class="notifications__text">${name}</p>
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;

export const getNotificationCloseTemplate = ({
                                               id,
                                               name,
                                               projectName,
                                               user,
                                               date,
                                               taskId,
                                             }, isSubItem) => `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--closed" href="/task/${taskId}">
    <p class="notifications__name">Задача закрыта</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19"
      alt="Аватар пользователя ${user.name}">
    <div class="notifications__content">
      <p class="notifications__text">${name}</p>
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;

export const getNotificationCommentTemplate = ({
                                                 id,
                                                 comment,
                                                 projectName,
                                                 user,
                                                 date,
                                                 taskId,
                                                 name,
                                               }, isSubItem) => `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--comment" href="/task/${taskId}">
    <p class="notifications__name">Комментарий к задаче</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19"
      alt="Аватар пользователя ${user.name}">
    <div class="notifications__content">
      ${!isSubItem ? `<p class="notifications__text">${name}</p>` : ``}
      <p class="notifications__text">${replaceMnemonicSymbols(comment)}</p>
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;

export const getNotificationResponsibleTemplate = ({
                                                     id,
                                                     name,
                                                     projectName,
                                                     user,
                                                     date,
                                                     currentUser,
                                                     newUser,
                                                     taskId,
                                                   }, isSubItem) => {
  return `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--responsible" href="/task/${taskId}">
    <p class="notifications__name">Изменение ответственного</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19"
      alt="Аватар пользователя ${user.name}">
    <div class="notifications__content">
      ${!isSubItem ? `<p class="notifications__text">${name}</p>` : ``}
      <div class="notifications__box">
        ${Boolean(currentUser) && `<div class="notifications__responsible">
          <img class="notifications__avatar" src="${currentUser.avatar}" width="19" height="19"
            alt="Аватар пользователя ${currentUser.name}">
          <p class="notifications__user">${currentUser.name}</p>
        </div>
        <span class="notifications__arrow">&#8594;</span>`}
        ${Boolean(newUser) && `<div class="notifications__responsible">
         <img class="notifications__avatar" src="${newUser.avatar}" width="19" height="19"
            alt="Аватар пользователя ${newUser.name}">
          <p class="notifications__user">${newUser.name}</p>
        </div>`}
      </div>
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;
};

export const getNotificationDeadlineTemplate = ({
                                                  id,
                                                  name,
                                                  projectName,
                                                  user,
                                                  date,
                                                  currentDate,
                                                  newDate,
                                                  taskId,
                                                }, isSubItem) => `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--deadline" href="/task/${taskId}">
    <p class="notifications__name">Изменение сроков</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19"
      alt="Аватар пользователя ${user.name}">
    <div class="notifications__content">
      ${!isSubItem ? `<p class="notifications__text">${name}</p>` : ``}
      <div class="notifications__box">
        <p class="notifications__text">${currentDate}</p>
        <span class="notifications__arrow">&#8594;</span>
        <p class="notifications__text">${newDate}</p>
      </div>
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;

export const getNotificationSubscribersTemplate = ({
                                                     id, name, projectName, user,
                                                     date, subscriber, taskId,
                                                   }, isSubItem) => {
  return `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--subscribe" href="/task/${taskId}">
    <p class="notifications__name">Добавление подписчика</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19"
      alt="Аватар пользователя ${user.name}">
    <div class="notifications__content">
      ${!isSubItem ? `<p class="notifications__text">${name}</p>` : ``}
      <div class="notifications__box">
        <div class="notifications__responsible">
          <img class="notifications__avatar" src="${subscriber.avatar}" width="19" height="19"
            alt="Аватар пользователя ${subscriber.name}">
          <p class="notifications__user">${subscriber.name}</p>
        </div>
      </div>
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;
};

export const getNotificationCallUserTemplate = ({
                                                  id, name, projectName, user,
                                                  date, taskId,
                                                }, isSubItem) => {
  return `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--call-user" href="/task/${taskId}">
    <p class="notifications__name">Вас позвали</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19"
      alt="Аватар пользователя ${user.name}">
    <div class="notifications__content">
      ${!isSubItem ? `<p class="notifications__text">${name}</p>` : ``}
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;
};

export const getNotificationChangePriorityTemplate = ({
                                                        id, name, projectName, user,
                                                        date, currentPriority, newPriority, taskId,
                                                      }, isSubItem) => {
  return `<li class="${isSubItem ? `notifications__subitem` : `notifications__item`} js-notification" data-notification-id="${id}"${!isSubItem ? ` data-n-task-id="${taskId}"` : ``}>
  <a class="notifications__elem notifications__elem--change-priority" href="/task/${taskId}">
    <p class="notifications__name">Изменение приоритета</p>
    <p class="notifications__project">${projectName}</p>
    <time class="notifications__time" datetime="${date}">${formattingDate(new Date(date), {showTime: true})}</time>
    <img class="notifications__avatar" src="${user.avatar}" width="19" height="19" alt="">
    <div class="notifications__content">
      ${!isSubItem ? `<p class="notifications__text">${name}</p>` : ``}
      <div class="notifications__box">
        <div class="priority priority--notifications">
          <div class="priority__block priority__block--priority-${currentPriority}">
            <span class="priority__text">${currentPriority}</span>
          </div>
          <span class="notifications__arrow">→</span>
          <div class="priority__block priority__block--priority-${newPriority}">
            <span class="priority__text">${newPriority}</span>
          </div>
        </div>
      </div>
    </div>
  </a>
  <button class="notifications__button js-notification-remove" type="button" aria-label="Убрать уведомление">
    <svg class="notifications__button-icon" width="19" height="19">
      <use xlink:href="/img/sprite.svg#icon-stop"></use>
    </svg>
  </button>
</li>`;
};

export const getDateItemListTemplate = (date) => {
  return `<div class="notifications__inner" data-notification-date="${date}">
    <div class="notifications__spacer">
      <span class="notifications__line notifications__line--first"></span>
      <time class="notifications__date" datetime="${date}">
        ${formattingDate(new Date(date), {})}
      </time>
      <span class="notifications__line notifications__line--second"></span>
    </div>
    <ul class="notifications__list js-notification-sub-list">
    </ul>
  </div>`;
};
